<div [formGroup]="formgroup" style="width: 200px;">
  <div class="header-color" [ngStyle]="{'background-color': typeHeaderParameters.color}"></div>
  <div class="header-text" [ngStyle]="{'border': typeHeaderParameters.border}">
    <div class="checkbox-selfcare">
      <mat-checkbox (change)="change(typeHeaderParameters.key, $event)" formControlName="value"></mat-checkbox>
    </div>
    <div class="text">
      <p style="width: 112px">{{ typeHeaderParameters.header }}</p>
    </div>
    <div class="title">
      {{ typeHeaderParameters.title }}
    </div>
  </div>
  @if (!formgroup.get('value').value) {
    <div class="bottom-color-noselected" [ngStyle]="{'background-color': typeHeaderParameters.color}"></div>
  }
  @if (formgroup.get('value').value) {
    <div class="bottom-color-selected" [ngStyle]="{'background-color': typeHeaderParameters.color}">
      <div class="arrow-down-selfcare" [ngStyle]="{'border-top': typeHeaderParameters.arrowBorder}"></div>
    </div>
    <div class="bottom-text" [ngStyle]="{'border': typeHeaderParameters.border}">
      <div class="text bottom-bolder">
        <p>{{ typeHeaderParameters.bottom }}</p>
      </div>
      @if(typeHeaderParameters.bottomInfos) {
        <div class="text bottom-infos">
          <p>{{ typeHeaderParameters.bottomInfos }}</p>
        </div>
      }
      <div class="price" [ngStyle]="{'color': typeHeaderParameters.color}">
        {{ typeHeaderParameters.price }}
      </div>
    </div>
  }
</div>


